import React from "react";

export default function OfflinePage() {
  const phone = "+916395050131";
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>You're Offline</h1>
        <p style={styles.subtitle}>
          No internet? Not a problem! You can still order medicines easily.
        </p>

        <button
          style={styles.callBtn}
          onClick={() => window.location.href = `tel:${phone}`}
        >
          📞 Call & Order Now
        </button>

        <a
          href={`https://wa.me/${phone}`}
          style={styles.whatsappBtn}
        >
          💬 Order on WhatsApp
        </a>

        <button
          style={styles.retryBtn}
          onClick={() => window.location.reload()}
        >
          🔄 Retry Connection
        </button>

        <div style={styles.features}>
          <p>✔ Fast Delivery</p>
          <p>✔ Prescription Support</p>
          <p>✔ Cash on Delivery</p>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f4f7fb",
  },
  card: {
    background: "#fff",
    padding: "30px",
    borderRadius: "20px",
    textAlign: "center",
    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
    maxWidth: "350px",
  },
  title: {
    fontSize: "26px",
    marginBottom: "10px",
  },
  subtitle: {
    color: "#666",
    marginBottom: "20px",
  },
  callBtn: {
    background: "#007bff",
    color: "#fff",
    padding: "12px",
    borderRadius: "10px",
    border: "none",
    width: "100%",
    marginBottom: "10px",
    fontSize: "16px",
  },
  whatsappBtn: {
    display: "block",
    background: "#25D366",
    color: "#fff",
    padding: "12px",
    borderRadius: "10px",
    textDecoration: "none",
    marginBottom: "10px",
  },
  retryBtn: {
    background: "#eee",
    padding: "10px",
    borderRadius: "10px",
    border: "none",
    width: "100%",
  },
  features: {
    marginTop: "20px",
    fontSize: "14px",
    color: "#555",
  },
};